import { MenuItem } from '../models/menu-item.model';

export const additinalMenu: MenuItem[] = [
    {
        url: '/eu-projects',
        name: 'FOOTER.ADDITIONAL_INFORMATIONS.projects',
    },
    {
        url: ['/legal', 'regulations'],
        name: 'FOOTER.ADDITIONAL_INFORMATIONS.regulations',
    },
    {
        url: ['/legal', 'privacy-policy'],
        name: 'FOOTER.ADDITIONAL_INFORMATIONS.privacy_policy',
    },
    {
        url: ['/legal', 'cookies-policy'],
        name: 'FOOTER.ADDITIONAL_INFORMATIONS.cookies_policy',
    },
];
